import { createStyles } from "@mantine/emotion";

export const useStylesPagePricing = createStyles((theme) => ({
  pricing: {
    backgroundColor: theme.customBackgrounds.page,
  },
  pricingHeader: {
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: "2.7em",
    [`@media (min-width: ${theme.breakpoints.md})`]: {
      paddingTop: "0",
    },
  },
  pricingTooltip: {
    backgroundColor: theme.customBackgrounds.greenLight,
    color: theme.customColors.black,
    padding: `${theme.spacing.pricing.padding.small} ${theme.spacing.pricing.padding.large}`,
    zIndex: "0 !important",
  },
  pricingTooltipContainer: {
    right: "-3.5em",
    position: "relative",
    padding: "0",
  },
  pricingTabs: {
    marginTop: "3.8em",
    marginBottom: "3.3em",
    [`@media (max-width: ${theme.breakpoints.md})`]: {
      marginTop: theme.spacing.pricing.margin.large,
    },
    button: {
      width: "7.13em",
    },
  },
  pricingBlock: {
    [`@media (max-width: ${theme.breakpoints.tabletCustomMax})`]: {
      justifyContent: "center !important",
    },
  },
  pricingBlockItem: {
    [`@media (max-width: ${theme.breakpoints.tabletCustomMax})`]: {
      flexBasis: "auto !important",
    },
  },
  pricingBlockItemFirst: {
    backgroundColor: theme.customBackgrounds.freePlan + "!important",
    color: theme.customColors.black + "!important",
    border: "1px solid hsla(0,0%,44%,.2)",
    svg: {
      fill: theme.customBackgrounds.pricingSecond + " !important",
    },
  },
  pricingBlockItemThird: {
    color: theme.customColors.black + "!important",
  },
  pricingBlockItemHead: {
    minHeight: "8em !important",
  },
  pricingBlockItemHeadWrap: {
    marginLeft: "auto",
    marginRight: "auto",
    display: "block",
    minHeight: "6.07em",
    paddingTop: theme.spacing.pricing.padding.large,
  },
  pricingBlockItemHeadWrapBreak: {
    flexBasis: "100%",
    height: "0",
    padding: "0",
    margin: "0",
  },
  pricingBlockItemHeadWrapCurrent: {
    backgroundColor: theme.customBackgrounds.greenLight,
    borderRadius: "0.57em",
    color: theme.customColors.black,
    fontFamily: theme.headings.fontFamily.bold,
    fontSize: theme.spacing.pricing.fontSize.small,
    minWidth: "7.21em",
    padding: "0.43em 0.79em 0.36em",
    width: "auto",
  },
  pricingBlockItemHeadSubtitle: {
    fontSize: theme.spacing.pricing.fontSize.large,
    fontFamily: theme.headings.fontFamily.bold,
    paddingTop: theme.spacing.pricing.padding.small,
    lineHeight: theme.spacing.pricing.lineHeight.small,
    span: {
      fontFamily: theme.headings.fontFamily.light,
      fontSize: "1em",
      lineHeight: theme.spacing.pricing.lineHeight.small,
    },
  },
  pricingBlockItemHeadSubTitleYear: {
    fontSize: "1.33em",
    paddingTop: "1em",
    width: "100%",
  },
  pricingBlockButtonsButton: {
    height: "2.45em",
  },

  pricingCustom: {
    width: "100%",
    overflow: "hidden",
    paddingLeft: "8.9%",
    marginTop: "3.33em",
    border: theme.customColors.borderCustomPlan,
    backgroundColor: theme.customBackgrounds.white,
    position: "relative",
    paddingBottom: "3.6em",
    [`@media (max-width: ${theme.breakpoints.tabletCustomMax})`]: {
      paddingLeft: "2em",
      paddingBottom: theme.spacing.pricing.margin.small,
    },
    [`@media (max-width: ${theme.breakpoints.md})`]: {
      display: "block",
      paddingBottom: "18.67em",
    },
  },
  pricingCustomItemFirst: {
    width: "31%",
    [`@media (max-width: ${theme.breakpoints.tabletCustomMax})`]: {
      paddingRight: theme.spacing.pricing.margin.small,
    },
    [`@media (max-width: ${theme.breakpoints.md})`]: {
      width: "15.33em",
    },
  },

  pricingCustomItemTitle: {
    fontSize: "2.80em",
    lineHeight: theme.spacing.pricing.lineHeight.medium,
    fontFamily: theme.headings.fontFamily.bold,
    paddingTop: "1.55em",
    marginBottom: "0.83em",
    [`@media (max-width: ${theme.breakpoints.tabletCustomMax})`]: {
      paddingTop: "0.69em",
      fontSize: "2.40em",
      lineHeight: "1.11em",
    },
  },

  pricingCustomButtons: {
    marginTop: theme.spacing.pricing.margin.large + " !important",
    [`@media (max-width: ${theme.breakpoints.md})`]: {
      display: "none",
    },
  },

  pricingCustomItemSecond: {
    paddingTop: "4.8em",
    position: "relative",
    zIndex: "1",
    maxWidth: "31%",
    [`@media (max-width: ${theme.breakpoints.tabletCustomMax})`]: {
      paddingTop: "2.13em",
    },
    [`@media (max-width: ${theme.breakpoints.md})`]: {
      width: "15.33em",
      paddingTop: "0",
      maxWidth: "none",
    },
  },

  pricingCustomItemLine: {
    paddingBottom: theme.spacing.pricing.padding.large,
    [`@media (max-width: ${theme.breakpoints.md})`]: {
      display: "none",
    },
    svg: {
      marginRight: "0.87em",
      position: "relative",
      top: "0.33em",
      fill: theme.customBackgrounds.pricingSecond,
      height: theme.spacing.pricing.margin.small,
    },
  },
  pricingCustomItemLineText: {
    fontFamily: theme.headings.fontFamily.light,
    fontSize: theme.spacing.pricing.fontSize.medium,
    lineHeight: "1.17em",
    [`@media (max-width: ${theme.breakpoints.tabletCustomMax})`]: {
      fontSize: "1.07em",
      lineHeight: "1.19em",
    },
    b: {
      fontFamily: theme.headings.fontFamily.bold,
      fontWeight: "normal",
      fontSize: "1em",
    },
  },

  pricingCustomItemImg: {
    position: "absolute",
    right: "-3.80em",
    width: "29.80em",

    [`@media (max-width: ${theme.breakpoints.tabletCustomMax})`]: {
      bottom: "-4.73em",
      right: "-4.67em",
      maxWidth: "24em",
    },
  },

  pricingCustomItemMobile: {
    display: "none",
    [`@media (max-width: ${theme.breakpoints.md})`]: {
      display: "block;",
      fontSize: theme.spacing.pricing.fontSize.medium,
    },

    span: {
      display: "block",
      fontFamily: theme.headings.fontFamily.light,
    },
  },
  changeSubscribeBlock: {
    width: "100%",
    flexDirection: "column",
  },
}));
